// eslint-disable-next-line max-classes-per-file
import { Action } from '@ngrx/store';
import { LiveAvailability } from '@cigna/omni/data-access';

export enum LiveAvailabilityActionTypes {
  GetLiveAvailability = '[Omni - LiveAvailability] GetLiveAvailability',
  GetLiveAvailabilitySuccess = '[Omni - LiveAvailability] LiveAvailabilitySuccess',
  PauseLiveAvailabilityCheck = '[Omni - LiveAvailability] Pause Live Availability Check',
  ResumeLiveAvailabilityCheck = '[Omni - LiveAvailability] Resume Live Availability Check',
}

export class GetLiveAvailability implements Action {
  public readonly type = LiveAvailabilityActionTypes.GetLiveAvailability;
}

export class GetLiveAvailabilitySuccess implements Action {
  public readonly type = LiveAvailabilityActionTypes.GetLiveAvailabilitySuccess;
  constructor(public liveAvailability: LiveAvailability) {}
}

export class PauseLiveAvailabilityCheck implements Action {
  public readonly type = LiveAvailabilityActionTypes.PauseLiveAvailabilityCheck;
}
export class ResumeLiveAvailabilityCheck implements Action {
  public readonly type =
    LiveAvailabilityActionTypes.ResumeLiveAvailabilityCheck;
}

export type LiveAvailabilityAction =
  | GetLiveAvailability
  | PauseLiveAvailabilityCheck
  | ResumeLiveAvailabilityCheck
  | GetLiveAvailabilitySuccess;

export const fromLiveAvailabilityActions = {
  GetLiveAvailability,
  GetLiveAvailabilitySuccess,
  PauseLiveAvailabilityCheck,
  ResumeLiveAvailabilityCheck,
};
